import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import type {
  TaxonomyDepartment,
  TaxonomyFunction,
  TaxonomyLabel,
  TaxonomyLocation,
  TaxonomyTheme,
} from '../../types/uncinc_profile/taxonomy';
import type { TagItem } from '.';

export function taxonomyTagEntityMapper(
  taxonomies: ReferenceField<TaxonomyLabel | TaxonomyTheme | TaxonomyFunction | TaxonomyLocation | TaxonomyDepartment>[],
): TagItem[] {
  const tagItems = taxonomies.map((taxonomy) => (
    {
      name: 'field_alternative_function_title' in taxonomy.entity && taxonomy.entity.field_alternative_function_title[0]?.value
        ? taxonomy.entity.field_alternative_function_title[0].value
        : taxonomy.entity.name[0].value,
      type: taxonomy.entity.vid[0].target_id,
      link: taxonomy.url,
    }
  ));

  return tagItems;
}

export function taxonomyTagElasticMapper(
  taxonomies?: string[],
  type?: string,
): TagItem[] {
  const tagItems = taxonomies?.map((taxonomy) => (
    {
      name: taxonomy,
      type,
    }
  ));

  return tagItems || [];
}
